/* NOXRAW light rebuild — minimal, defensive UI enhancements.
   Only adds a class on scroll for the header shadow. No deps. */
(function () {
  try {
    var toggle = function () {
      if (window.scrollY > 8) document.body.classList.add('nx-scrolled');
      else document.body.classList.remove('nx-scrolled');
    };
    window.addEventListener('scroll', toggle, { passive: true });
    document.addEventListener('DOMContentLoaded', toggle);
    toggle();
  } catch (e) { /* fail silently — never break the storefront */ }
})();
